import { keepPreviousData } from "@tanstack/react-query"

import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_VERTICAL_SIGNING } from "../../../../../common/constants/modules"

import { verticalSigningQueryKeys } from "./queryKeys"
import { useVerticalSigningQuery } from "./useVerticalSigningQuery"


export function useVerticalSigningGrades(config = {}, parameters = {}) {
    const url = "vertical_signs/stats/conditions/"

    const queryParameters = useExtendWithSubnetworks(parameters, API_MODULE_VERTICAL_SIGNING)

    const queryKey = verticalSigningQueryKeys["stats_conditions"](queryParameters)

    return useVerticalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            ...config,
            placeholderData: keepPreviousData,
        },
    )
}
